import { useCallback } from "react";

import { useFormActions, useFieldValue } from "2g-form/hooks";

import useDelete from "./useDelete";
import useImagePreview from "./useImagePreview";

export default function useImageChooser(path) {
  const value = useFieldValue(path);
  const image = value?.[0];
  const actions = useFormActions();
  const onDelete = useDelete();

  const imagePreview = useImagePreview(image);
  const onChangeInternal = useCallback(
    newValue => {
      if (newValue) {
        actions.setValue(path, newValue);
      } else {
        if (image?.key) {
          onDelete(image, () => actions.setValue(path));
        } else {
          actions.setValue(path);
        }
      }
    },
    [image, onDelete]
  );

  return { onChange: onChangeInternal, value, imagePreview };
}
